import { render, staticRenderFns } from "./Segmentacao.vue?vue&type=template&id=6007b09e&scoped=true"
import script from "./Segmentacao.vue?vue&type=script&lang=js"
export * from "./Segmentacao.vue?vue&type=script&lang=js"
import style0 from "./Segmentacao.vue?vue&type=style&index=0&id=6007b09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007b09e",
  null
  
)

export default component.exports